<template>
  <div :style="{backgroundColor: $common.transparent ? bg_color : '#FFFFFF'}">
    <!--        <div @click="clickSearch" v-if="$common.isClient_whole() && !channel_name">-->
    <!--            <Wp_search_model style="padding: 0px 5px" :font-color="font_color" :common-transparent="$common.transparent"></Wp_search_model>-->
    <!--            <div :style="{height: '52px', width: $common.screenWidth + 'px', position: 'absolute', top: '0px'}">-->

    <!--            </div>-->
    <!--        </div>-->
    <Wp_home_all_model :top-px="topPx" @getColors="getColors"></Wp_home_all_model>
  </div>
</template>

<script>
import Wp_home_all_model from '../custom_model/Wp_home_all_model'
// import Wp_search_model from "../custom/Wp_search_model";
export default {
  name: 'Wp_jd_home_simple',
  components: { Wp_home_all_model },
  inject: ['wp_group_owner_app'],

  // provide() {
  //     return {
  //         Wp_jd_home_simple : this
  //     }
  // },

  data () {
    return {
      bg_color: '',
      font_color: '',
      channel_name: '',
      topPx: '15px',
    }
  },

  created () {
    this.channel_name = this.$common.getUrlKey('channel_name')
    // if(this.$common.isClient_hm()){
    //     this.topPx = '110px';
    // }
  },

  mounted () {
    this.wp_group_owner_app.showTab = false
    this.$common.transparent = true
  },

  methods: {
    clickSearch () {
      this.$router.push('select?isInput=true')
    },

    getColors (colors) {
      this.bg_color = colors.bg_color
      this.font_color = colors.font_color

      this.$emit('getColors', colors)
    }
  }
}
</script>

<style scoped>

</style>